<div class="message-modal">
  <img alt="" aria-hidden="true" class="header-image" src="/assets/images/illustration-58.svg">
  <h1 class="title" i18n="@@popup.requiredAssistanceServices.title" id="modal-title">Uns fehlt da noch was!</h1>
  @if (!modal.data.isGiver) {
    <p class="body" i18n="@@popup.requiredAssistanceServices.isGiver.content">Um Ihnen bei
        der Suche zu helfen, brauchen wir mindestens eine Angabe, in welchem Bereich Sie Unterstützung benötigen. Sie
        können Ihre Angaben jederzeit im «Profil» anpassen.</p>
  }
  @if (modal.data.isGiver) {
    <p class="body" i18n="@@popup.requiredAssistanceServices.isRecipient.content">Damit
        Assistenzsuchende Sie schneller finden, benötigen wir mindestens eine Angabe, in welchem Bereich Sie
        Unterstützung anbieten möchten. Sie können Ihre Angaben jederzeit im «Profil» anpassen.</p>
  }
  <div class="action">
    <button (click)="close()" class="button primary" i18n="@@popup.requiredAssistanceServices.btnOk">Alles klar
        </button>
  </div>
</div>
